<template lang="pug">
  ul.TheFooterMenu.footer-menu(
    itemscope,
    itemtype="https://schema.org/SiteNavigationElement",
  )
    li(
      v-for="child in children"
    )
      router-link.link-1(
        v-if="child.path.startsWith('/')",
        :to="child.path",
        itemprop="url"
      )
        span(itemprop="name") {{ child.name }}
      a(
        v-else,
        :href="child.path",
        itemprop="url",
        target="_blank",
      ).link-1
        span(itemprop="name") {{ child.name }}
</template>

<script>

export default {
  name: 'TheFooterMenu',
  props: {
    children: Array,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
ul
  list-style-type: none
  padding-left: 0
  margin-left: 0
  display: flex
  flex-direction: row
  justify-content: space-between
  margin-top: 25px
  flex-wrap: wrap
  li
    @media screen and (max-width: 576px)
      width: calc(50% - 25px)
      flex-shrink: 0
      padding-bottom: 10px
      &:nth-child(1)
        order: 0
      &:nth-child(2)
        order: 2
      &:nth-child(3)
        order: 1
      &:nth-child(4)
        order: 3
      &:nth-child(5)
        order: 4
    a
      font-family: $font-regular
      font-weight: 400
      line-height: 17px
</style>
